import { useTranslation } from 'react-i18next';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import { PoolMaintenanceLoaderFeedback } from './PoolMaintenanceLoaderFeedback';
import { useDeletePool } from './hooks/useDeletePool';
import { useGetColumns } from './hooks/useGetColumns';
import { useGetPoolMaintenanceTableData } from './hooks/useGetPoolMaintenanceTableData';

const PoolMaintenance = () => {
  const { t } = useTranslation();

  const columns = useGetColumns();

  const { isFetching, data, isError, refetch } =
    useGetPoolMaintenanceTableData();
  const { mutate: deleteRow } = useDeletePool();

  const handleDeleteRow = async (id) => {
    await deleteRow(id);
  };

  return (
    <TableCRUDLayout
      FormComponent={PoolMaintenanceLoaderFeedback}
      rows={data}
      loading={isFetching}
      columns={columns}
      confirmationTitle={t('deleteDialog.title')}
      confirmationBody={t('deleteDialog.body')}
      initialState={{
        sorting: { sortModel: [{ field: 'code', sort: 'asc' }] }
      }}
      onDeleteClick={handleDeleteRow}
      hasLoadingError={isError}
      onLoadingError={refetch}
    />
  );
};

export default PoolMaintenance;
